import { render, staticRenderFns } from "./bometerdata_detail.vue?vue&type=template&id=476f39d8&"
import script from "./bometerdata_detail.vue?vue&type=script&lang=js&"
export * from "./bometerdata_detail.vue?vue&type=script&lang=js&"
import style0 from "./bometerdata_detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports